export const getInitialProps = async ({
  routeInfo,
  context: {
    domain,
    i18n: {culture}
  }
}) => {
  const {
    location: {pathname: path}
  } = routeInfo

  const {pageName} = await domain.get('get_page_name_page_use_case').execute({path})

  const getSeoDataPromise = () =>
    domain.get('get_seo_data_use_case').execute({
      culture,
      pageName
    })

  const getUserByIdPromise = () => domain.get('get_user_by_id_user_use_case').execute()

  const [
    {
      value: [, {head: helmet} = {}]
    },
    {
      value: [, userData]
    }
  ] = await Promise.allSettled([getSeoDataPromise(), getUserByIdPromise()])

  return {helmet, pageName, userData}
}
